import { API_BASE_URL } from '../../../../api';
import React, { useState, useContext, useEffect } from "react";
import { AccountContext } from "../../../../Contexts/main.context";

const CreateUser = () => {
     const [formData, setFormData] = useState({
          displayName: "",
          email: "",
          iconSex: "Male",
          phone: "",
          hashPass: "",
          accountSecurity: "Manager",
     });

     const { updateActiveOutlet, updateMasked } = useContext(AccountContext)

     const handleChange = (e) => {
          const { name, value } = e.target;
          setFormData((prev) => ({ ...prev, [name]: value }));
     };

     useEffect(() => {
          updateMasked(true);
     }, []);

     const handleSubmit = async (e) => {
          e.preventDefault();
          const updatedClient = { ...formData, script: "createUser" };
          try {
               const response = await fetch(API_BASE_URL + 'data.php', {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(updatedClient),
               });

               const data = await response.json();
               if (data.status === "success") {
                    cancelCreate();
               } else {
                    alert(data.message);
               }
          } catch (error) {
               alert("An error occurred Saving Data");
          }
     };

     const cancelCreate = () => {
          setFormData({
               displayName: "",
               email: "",
               iconSex: "Male",
               phone: "",
               hashPass: "",
               accountSecurity: "Manager",
          });
          updateActiveOutlet('Users');
          updateMasked(false);
     }

     return (
          <div className="col-46 offset-1 mt-4">
               <h3 className="text-center mb-3">Create New User</h3>
               <div className="w-100 fs-5 text-center mb-2">This routine does not automatically email the new user. You will manually have to let the user know of their account. The Icon Choice is only there so it will either put a Male or Female Icon as the placeholder until the user changes their image. </div>
               <form onSubmit={handleSubmit} className="p-4 border rounded bg-light">
                    <div className="d-flex gap-2">
                         <div className="mb-3 col-24">
                              <label className="form-label">Name</label>
                              <input type="text" name="displayName" value={formData.displayName} onChange={handleChange} className="form-control" required />
                         </div>

                         <div className="flex-grow-1">
                              <label className="form-label">Email</label>
                              <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" required />
                         </div>
                    </div>
                    <div className="d-flex gap-2">
                         <div className="col-12 mb-3">
                              <label className="form-label">Icon Choice</label>
                              <select name="iconSex" value={formData.iconSex} onChange={handleChange} className="form-select">
                                   <option value="Male">Male</option>
                                   <option value="Female">Female</option>
                              </select>
                         </div>

                         <div className="col-12 mb-3">
                              <label className="form-label">Phone</label>
                              <input type="text" name="phone" value={formData.phone} onChange={handleChange} className="form-control" />
                         </div>

                         <div className="col-12 mb-3">
                              <label className="form-label">Password</label>
                              <input type="text" name="hashPass" value={formData.hashPass} onChange={handleChange} className="form-control" required />
                         </div>
                         <div className="flex-grow-1 mb-3">
                              <label className="form-label">Account Security</label>
                              <select name="accountSecurity" value={formData.accountSecurity} onChange={handleChange} className="form-select">
                                   <option value="Manager">Manager</option>
                                   <option value="Admin">Admin</option>
                              </select>
                         </div>
                    </div>
                    <div className="w-100 d-flex gap-2 justify-content-center">
                         <button className="btn btn-danger col-12 mt-3" onClick={() => cancelCreate()}>Cancel</button>
                         <button type="submit" className="btn btn-primary col-12 mt-3">Create User</button>
                    </div>
               </form>
          </div>
     );
};

export default CreateUser;
